import { Component, OnInit } from '@angular/core';
import { AccessUserInfo } from 'src/app/models';

@Component({
  selector: 'bart-admin-main',
  templateUrl: './admin-main.component.html',
  styleUrls: ['./admin-main.component.scss']
})
export class AdminMainComponent implements OnInit {

  userDetail :any  =null;
  constructor() { 

    this.userDetail = AccessUserInfo.getUserInfo();
  }

  ngOnInit() {
  }

}
